class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      });
    });
  }
}

if (!customElements.get('cart-item-tool')) {
  customElements.define('cart-item-tool', CartTool);
}

class CartCancel extends HTMLElement {
  constructor() {
    super();

    this.querySelector('button').addEventListener('click', () => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    });
  }
}

if (!customElements.get('cart-cancel-popup')) {
  customElements.define('cart-cancel-popup', CartCancel);
}

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[data-update-note]').addEventListener('click', () => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${window.routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    });
  }
}

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', CartNote);
}

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')) {
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', () => {
      this.val = this.querySelector('input[name="discount"]').value;
      localStorage.setItem('storedDiscount', this.val);
      fetch(`/discount/${this.val}`)
        .then((response) => response.text())
        .then(() => {
          Shopify.getCart((cart) => {
            window.sharedFunctions?.updateSidebarCart(cart);
          });
        });
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    });
  }
}

if (!customElements.get('coupon-code')) {
  customElements.define('coupon-code', CouponCode);
}

(function () {
  if (window.__haloSidebarCartRemoveBound) return;
  window.__haloSidebarCartRemoveBound = true;

  let quantityTimer;

  async function refreshSidebarCart(cart) {
    const wrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper')
      || document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
    if (!wrapper || !window.routes?.root) return;

    const response = await fetch(`${window.routes.root}/cart?view=ajax_side_cart`, { cache: 'no-store' });
    const html = await response.text();
    wrapper.innerHTML = html;

    if (cart == null) {
      cart = await fetch(`${window.routes.cart || '/cart'}.js`).then((res) => res.json());
    }

    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count >= 100 ? (window.cartStrings?.item_99 || '99+') : cart.item_count;
    });

    document.querySelectorAll('[data-cart-text]').forEach((el) => {
      el.textContent = cart.item_count === 1
        ? (window.cartStrings?.item || 'item')
        : (window.cartStrings?.items || 'items');
    });

    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));

    if (typeof jQuery !== 'undefined') {
      jQuery(document).trigger('sidebar-cart:refreshed');
    }
  }

  function getLinePayload(source) {
    const lineKey = source.getAttribute('data-line');
    const lineIndex = source.getAttribute('data-index');
    return { lineKey, lineIndex };
  }

  async function changeSidebarCartLine(source, quantity) {
    const { lineKey, lineIndex } = getLinePayload(source);

    async function request(payload) {
      const response = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const cart = await response.json();
      if (!response.ok || cart.status === 422) {
        throw new Error(cart.description || cart.message || 'Cart update failed');
      }
      return cart;
    }

    if (lineKey && lineKey.includes(':')) {
      try {
        return await request({ id: lineKey, quantity });
      } catch (error) {
        if (lineIndex) {
          return await request({ line: parseInt(lineIndex, 10), quantity });
        }
        throw error;
      }
    }

    if (lineIndex) {
      return await request({ line: parseInt(lineIndex, 10), quantity });
    }

    throw new Error('Cart update failed');
  }

  async function removeSidebarCartLine(source) {
    if (source.disabled) return;

    source.disabled = true;
    source.classList.add('is-loading');

    try {
      const cart = await changeSidebarCartLine(source, 0);
      await refreshSidebarCart(cart);
    } catch (error) {
      source.disabled = false;
      source.classList.remove('is-loading');
      if (typeof showWarning === 'function') {
        showWarning(error.message, 3000);
      }
      await refreshSidebarCart(null);
    }
  }

  async function updateSidebarCartQuantity(input) {
    const quantity = parseInt(input.value, 10);
    if (Number.isNaN(quantity)) return;

    const removeSource = input.closest('.previewCartItem')?.querySelector('[data-cart-remove]') || input;

    if (quantity <= 0) {
      await removeSidebarCartLine(removeSource);
      return;
    }

    input.disabled = true;

    try {
      const cart = await changeSidebarCartLine(input, quantity);
      await refreshSidebarCart(cart);
    } catch (error) {
      input.disabled = false;
      if (typeof showWarning === 'function') {
        showWarning(error.message, 3000);
      }
      await refreshSidebarCart(null);
    }
  }

  document.addEventListener('click', (event) => {
    const sidebar = event.target.closest('#halo-cart-sidebar');
    if (!sidebar) return;

    const removeButton = event.target.closest('[data-cart-remove]');
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      removeSidebarCartLine(removeButton);
      return;
    }

    const qtyButton = event.target.closest('.btn-quantity');
    if (!qtyButton) return;

    const qtyWrapper = qtyButton.closest('cart-update-quantity');
    const input = qtyWrapper?.querySelector('[data-cart-quantity]');
    if (!input) return;

    const currentVal = parseInt(input.value, 10);
    const isMinus = qtyButton.classList.contains('minus');
    const isPlus = qtyButton.classList.contains('plus');

    if (isMinus && currentVal <= 1) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      const removeSource = input.closest('.previewCartItem')?.querySelector('[data-cart-remove]') || input;
      removeSidebarCartLine(removeSource);
      return;
    }

    if (isPlus || isMinus) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      let nextVal = currentVal;
      if (isPlus) nextVal = currentVal + 1;
      if (isMinus) nextVal = Math.max(1, currentVal - 1);

      input.value = nextVal;
      clearTimeout(quantityTimer);
      quantityTimer = setTimeout(() => {
        updateSidebarCartQuantity(input);
      }, 250);
    }
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target.closest('#halo-cart-sidebar [data-cart-quantity]');
    if (!input) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    clearTimeout(quantityTimer);
    quantityTimer = setTimeout(() => {
      updateSidebarCartQuantity(input);
    }, 300);
  }, true);

  window.refreshSidebarCart = refreshSidebarCart;
})();
